import URI from 'urijs';

export const getQueryParam = (url, paramKey) => {
  const query = new URI(url).query();
  const params = URI.parseQuery(query);
  return params[paramKey] || '';
};
